import { render, staticRenderFns } from "./EmergencyContactsSection.vue?vue&type=template&id=67de0980&"
import script from "./EmergencyContactsSection.vue?vue&type=script&lang=js&"
export * from "./EmergencyContactsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports